var modalProduct = {

	// ----- VARS ----- //
	elms: {
		close: undefined,
		content: undefined,
		modal: undefined,
		product: {
			brand: undefined,
			title: undefined,
			description: undefined,
			imageSmall: undefined,
			imageLarge: undefined,
			productPrice: undefined,
			brandUrl: undefined,
			brandMapUrl: undefined
		}
	},

	// ----- CONSTANTS ----- //
	EVENT_TRANSITION: 'animationend webkitAnimationEnd oanimationend MSAnimationEnd',

	// ----- FUNCTIONS ----- //
	init: function() {
		//console.log( 'modalProduct: init' );

	    // find modal
		modalProduct.elms.modal = $( '#product-modal' );

		if (!modalProduct.elms.modal.length) {
		    //console.warn('No modal found in page');
		    return;
		}

		// find triggers
		var triggers = $( '[data-toggle="modal"]' );

		if (!triggers.length) {
		    //console.warn('No modal triggers found in page');
		    return;
		}

		// find trigger containers
		var containers = $('.products-list, .product-carousel, .products, .product-page, .component-latest-trends, .component-wear, .small-product-carousel');

		if (!containers.length) {
		    //console.warn('No modal trigger container found in page');
		    return;
		}

		// this way jQuery will target elements lazily loaded
	    containers.on( 'click', triggers, modalProduct.productClickHandler );

		$(document).keyup(function(e){
			e = e || window.event;

			// don't hide if zoom-open is open (or closing)
			if (e.keyCode == 27 && $('.zoom-open').length < 1) {
				modalProduct.hideModal();
			}
		});

		modalProduct.elms.close = modalProduct.elms.modal.find( '[data-dismiss="modal"]' );

		// event handlers
		modalProduct.elms.modal.on( 'click', modalProduct.modalClickHandler );
		modalProduct.elms.close.on( 'click', modalProduct.onClose );

		// assign elements
		modalProduct.elms.product.brand = $('#product-brand', modalProduct.elms.modal);
		modalProduct.elms.product.title = $('#product-title', modalProduct.elms.modal);
		modalProduct.elms.product.description = $('#product-description', modalProduct.elms.modal);
		modalProduct.elms.product.imageSmall = $('#product-image', modalProduct.elms.modal);
		modalProduct.elms.product.imageLarge = $('#product-zoom-image', modalProduct.elms.modal);
		modalProduct.elms.product.price = $('#product-price', modalProduct.elms.modal);
		modalProduct.elms.product.brandUrl = $('#product-brand-url', modalProduct.elms.modal);
		modalProduct.elms.product.brandMapUrl = $('#product-brand-map-url', modalProduct.elms.modal);

		// check if should open modal
		var featuredProductId = $('[data-featured-product-id]').attr('data-featured-product-id');

		if (featuredProductId) {
			containers.find("[data-product-id='" + featuredProductId + "']").click();
		}
	},

	showModal: function( selector ) {
		//console.log( 'modalProduct: show, selector:', selector );

		// scrollhack to avoid page jumping with modalProduct. will work with new navigation. desktop only (breaks zoom in mobile)
		// var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		// $('body').css('top', -(scrollTop) + 'px').addClass('modal-open');
		// $('body').addClass('modal-open');
        //console.log('Whats my selector? ' + selector)

		modalProduct.elms.modal.css( 'display', 'flex' );
		modalProduct.elms.modal.addClass( 'in' );

	    // Populate Modal Content
		modalProduct.elms.product.brand.html( selector.data('brand') );
		modalProduct.elms.product.title.html( selector.data('title') );
		modalProduct.elms.product.description.html( selector.data('description') );

	    // Price
		modalProduct.elms.product.price.html( selector.find('.product-price').clone() );

        // Images
		modalProduct.elms.product.imageSmall.attr('src', selector.data('image-src') );
		modalProduct.elms.product.imageSmall.attr('alt', selector.data('title') );
		modalProduct.elms.product.imageLarge.attr('data-img-zoom', selector.data('zoom-image-src') );
		modalProduct.elms.product.imageLarge.attr('alt', selector.data('title') );

		// Links
		modalProduct.elms.product.brandUrl.attr('href', selector.data('brand-url') );
		modalProduct.elms.product.brandMapUrl.attr('href', selector.data('map-url') );

        // Sharing
		modalProduct.elms.modal.attr('data-share-url', selector.data('share-url') );
		modalProduct.elms.modal.attr('data-title', selector.data('title') );
		modalProduct.elms.modal.attr('data-share-image', selector.data('share-image') );

		var $shareItems = modalProduct.elms.modal.find( '.share-item > a' );

		socialLinks.create( $shareItems, selector );
	},

	hideModal: function() {
		//console.log( 'modalProduct: hide' );

		if ( modalProduct.elms.modal ) {

			// Remove Listeners
			modalProduct.elms.modal.off( 'click', modalProduct.onClose );

			// Hide Modal
			modalProduct.elms.modal.removeClass( 'in' );			
			modalProduct.elms.modal.one( modalProduct.EVENT_TRANSITION, modalProduct.onHideComplete );
		}
	},

	// ----- EVENT LISTENERS ----- //

	productClickHandler: function( e ) {
	    //console.log('modalProduct: productClickHandler, e.target:', e.target);

		// look for the element with the trigger
	    var selector = $(e.target).closest($('[data-toggle="modal"]'));

		// if there's one, open modal
		if (selector.length){
			modalProduct.showModal( selector );
		}
	},

	modalClickHandler: function( e ) {
		//console.log( 'modalClickHandler' );

		// if clicked on the black overlay, close modal
		if ( e.target == modalProduct.elms.modal[0] ){
			modalProduct.hideModal();
			return;
		}
	},

	onClose: function( e ) {
		//console.log( 'modalProduct: onClose'  );

		e.stopPropagation();
		modalProduct.hideModal();

	},

	onHideComplete: function( e ) {
		//console.log( 'modalProduct: onHideComplete' );

		e.stopImmediatePropagation();

		// Hide Modal
		modalProduct.elms.modal.css( 'display', 'none' );

		// Unassign Variables and Remove Listeners
		modalProduct.elms.modal.off( modalProduct.EVENT_TRANSITION, modalProduct.onHideComplete );

		// $('body').removeClass('modal-open');

		// Reset zoom img container and product modal img
		$('#product-zoom-image').add(modalProduct.elms.product.imageSmall).attr('src', '/assets/img/src/transparent-video-img.png').removeAttr('data-img-zoom').removeAttr('style').removeAttr('src');

		// scrollhack to avoid page jumping with modalProduct. will work with new navigation. desktop only (breaks zoom in mobile)
		// var scrollTop = -parseInt($('body').css('top'), 10);
		// $('body').removeClass('modal-open').css('top', 0);
		// window.pageYOffset = document.documentElement.scrollTop = document.body.scrollTop = scrollTop;
	}
};